export default __webpack_public_path__ + "static/media/landing-family.2cdac581.jpg";